import { render, staticRenderFns } from "./SignUpEmailConfirm.vue?vue&type=template&id=177f2a88&"
import script from "./SignUpEmailConfirm.vue?vue&type=script&lang=ts&"
export * from "./SignUpEmailConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports